import React from 'react';

const AboutAIDay = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-outfit font-800 text-black mb-8 text-center">
            What is <span className="text-crimson">AI Day</span>?
          </h2>
          
          <p className="text-lg font-outfit font-600 text-gray-700 mb-12 text-center leading-relaxed">
            AI Day is a quarterly, community-first AI experience where students, developers, founders, 
            and professionals come together to:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-crimson transition-all duration-300 shadow-sm">
              <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-outfit font-800 text-black mb-3">
                Showcase real-world AI projects
              </h3>
              <p className="text-gray-600 font-outfit font-600">
                Present innovative AI solutions and learn from practical implementations
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-crimson transition-all duration-300 shadow-sm">
              <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-outfit font-800 text-black mb-3">
                Learn through hands-on workshops
              </h3>
              <p className="text-gray-600 font-outfit font-600">
                Participate in interactive sessions led by industry experts
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-crimson transition-all duration-300 shadow-sm">
              <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-outfit font-800 text-black mb-3">
                Engage with industry leaders
              </h3>
              <p className="text-gray-600 font-outfit font-600">
                Network with professionals and gain insights from AI practitioners
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg border border-gray-200 hover:border-crimson transition-all duration-300 shadow-sm">
              <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-outfit font-800 text-black mb-3">
                Build meaningful collaborations
              </h3>
              <p className="text-gray-600 font-outfit font-600">
                Connect with like-minded individuals and create lasting partnerships
              </p>
            </div>
          </div>

          <p className="text-center text-lg font-outfit font-600 text-gray-700">
            Designed & hosted by <a href="https://aianytime.net/" target="_blank" rel="noopener noreferrer" className="text-crimson font-800 hover:underline">AI Anytime</a> (Sankhyantra Foundation) — 
            built for learning, not hype.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutAIDay;
